import React from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Info from './info';
import Chip from '@mui/material/Chip';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const SellerClientOrders = () => {

    const [lastUpdate, setLasUpdate] = React.useState('Sin datos');

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Estado de pedidos de mis clientes
                    </Typography>
                </div>
                <hr />
                {
                    <Info setLastUpdate={(date) => setLasUpdate(date)} />
                }                
            </Grid>
        </Grid>
    );
}

export default SellerClientOrders;